import React from 'react';
import { reduxForm, Field } from 'redux-form';
import PropTypes from 'prop-types';
import { Button, Checkbox, Segment, Header, Icon } from 'semantic-ui-react';
import * as _ from 'lodash';

import { RegisterFieldEnum } from '../../../common/FieldEnum';
import BaseForm from '../../../components/forms/BaseForm';
import {
  renderLargeField,
  isValidEmail,
  FieldWithExtractedReduxActions,
  renderField,
} from '../../../common/FormHelper';
import { StyledReduxFormError } from '../../../components';
import withKeyboard from 'Common/Components/Keyboard/withKeyboard';
import withReduxFormBlur from 'Common/Components/Keyboard/withReduxFormBlur';
import { SelectField } from 'Common/SemanticWrapper';
import { getFiscalYear } from 'Common/GeneralHelper';

const LargeFieldWithKeyboard = FieldWithExtractedReduxActions(
  withReduxFormBlur(withKeyboard(renderLargeField))
);

class RegistrationForm extends BaseForm {
  constructor(props) {
    super(props);

    this.state = { ...this.state, settingsDisplay: false };
    this.inputRefs = [
      React.createRef(),
      React.createRef(),
      React.createRef(),
      React.createRef(),
      React.createRef(),
      React.createRef(),
    ];
    this.activeInputIndex = 0;
    this.registerBtnRef = React.createRef();
  }

  static propTypes = {
    initialValues: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    isFirstRegistration: PropTypes.bool,
  };

  static defaultProps = {
    isFirstRegistration: false,
  };

  currentFiscalYear = getFiscalYear(new Date());

  fiscalYearOptions = [this.currentFiscalYear, this.currentFiscalYear + 1].map(
    i => ({ key: i, text: i, value: i })
  );

  onKeyboardInputFocus = index => e => {
    this.activeInputIndex = index;
  };

  onKeyboardInputTab = () => {
    const nextInputIndex = this.activeInputIndex + 1;

    if (nextInputIndex !== this.inputRefs.length) {
      const nextInput = this.inputRefs[nextInputIndex].current.wrappedInstance;
      nextInput.focus();
    }
  };

  settings() {
    const { ui } = this.props;

    return (
      <div className="login--settings">
        <div className="settings--keyboard">
          <Checkbox
            label="Display Touch Screen Keyboard?"
            checked={ui.keyboardActive}
            onChange={(e, data) => {
              this.keyboardUseToggle();
            }}
          />
        </div>
      </div>
    );
  }

  render() {
    const {
        handleSubmit,
        submitting,
        invalid,
        error,
        isFirstRegistration,
      } = this.props,
      { settingsDisplay } = this.state;

    return (
      <div>
        <form onSubmit={handleSubmit}>
          <div>
            <Field
              name={RegisterFieldEnum.DistrictId}
              component={LargeFieldWithKeyboard}
              type="text"
              placeholder="District Code"
              label="District Code"
              attr={{
                autoComplete: 'new-password',
              }}
              forwardRef={this.inputRefs[0]}
              onFocus={this.onKeyboardInputFocus(0)}
              onTabPress={this.onKeyboardInputTab}
              useMargin
            />
          </div>
          <div>
            <Field
              name={RegisterFieldEnum.Username}
              component={LargeFieldWithKeyboard}
              type="text"
              maxLength={10}
              placeholder={isFirstRegistration ? 'Old Username' : 'Username'}
              label={isFirstRegistration ? 'Old Username' : 'Username'}
              attr={{
                autoComplete: 'new-password',
              }}
              forwardRef={this.inputRefs[1]}
              onFocus={this.onKeyboardInputFocus(1)}
              onTabPress={this.onKeyboardInputTab}
              useMargin
            />
          </div>
          {isFirstRegistration && (
            <div>
              <Field
                name={RegisterFieldEnum.NewUsername}
                component={LargeFieldWithKeyboard}
                type="text"
                maxLength={10}
                placeholder="New Username"
                label="New Username"
                attr={{
                  autoComplete: 'new-password',
                }}
                forwardRef={this.inputRefs[1]}
                onFocus={this.onKeyboardInputFocus(1)}
                onTabPress={this.onKeyboardInputTab}
                useMargin
              />
            </div>
          )}
          <div>
            <Field
              name={RegisterFieldEnum.OldPassword}
              component={LargeFieldWithKeyboard}
              type="password"
              placeholder="Old Password"
              label="Old Password"
              attr={{
                autoComplete: 'new-password',
              }}
              forwardRef={this.inputRefs[2]}
              onFocus={this.onKeyboardInputFocus(2)}
              onTabPress={this.onKeyboardInputTab}
              useMargin
            />
          </div>
          <div>
            <Field
              name={RegisterFieldEnum.NewPassword}
              component={LargeFieldWithKeyboard}
              type="password"
              placeholder="New Password"
              label="New Password"
              attr={{
                autoComplete: 'new-password',
              }}
              forwardRef={this.inputRefs[3]}
              onFocus={this.onKeyboardInputFocus(3)}
              onTabPress={this.onKeyboardInputTab}
              useMargin
            />
          </div>
          <div>
            <Field
              name={RegisterFieldEnum.ConfirmPassword}
              component={LargeFieldWithKeyboard}
              type="password"
              placeholder="Confirm Password"
              label="Confirm Password"
              attr={{
                autoComplete: 'new-password',
              }}
              forwardRef={this.inputRefs[4]}
              onFocus={this.onKeyboardInputFocus(4)}
              onTabPress={this.onKeyboardInputTab}
              useMargin
            />
          </div>
          <div>
            <Field
              name={RegisterFieldEnum.Email}
              component={LargeFieldWithKeyboard}
              type="text"
              placeholder="Email Address"
              label="Email Address"
              attr={{
                autoComplete: 'new-password',
              }}
              forwardRef={this.inputRefs[5]}
              onFocus={this.onKeyboardInputFocus(5)}
              onTabPress={this.onKeyboardInputTab}
              useMargin
            />
          </div>
          {isFirstRegistration && (
            <Segment color="orange">
              <Header as="h4">
                <Icon name="key" />A License Is Required
              </Header>
              <Field
                name={RegisterFieldEnum.FiscalYear}
                component={SelectField}
                label="Starting Fiscal Year"
                type={'text'}
                placeholder={'Starting Fiscal Year'}
                options={this.fiscalYearOptions}
              />
              <Field
                name={RegisterFieldEnum.LicenseFile}
                label="Upload your license file"
                component={renderField}
                type={'file'}
                accept={'.mpx'}
              />
            </Segment>
          )}
          <p>
            <StyledReduxFormError error={error} />
          </p>
          <div className="login--buttons">
            <Button
              primary
              floated="left"
              type="button"
              icon="settings"
              size="tiny"
              className="login--settings-trigger"
              onClick={event => {
                event.preventDefault();
                this.setState({
                  settingsDisplay: !this.state.settingsDisplay,
                });
              }}
            />
            <Button
              primary
              type="submit"
              floated="right"
              disabled={submitting || invalid}
              loading={this.props.isSubmitting}
            >
              Register
            </Button>
          </div>
          {!settingsDisplay ? null : this.settings()}
        </form>
      </div>
    );
  }
}

const validate = (values, props) => {
  const errors = {};

  if (
    !values[RegisterFieldEnum.DistrictId] ||
    (values[RegisterFieldEnum.DistrictId] &&
      _.trim(values[RegisterFieldEnum.DistrictId]).length < 1)
  ) {
    errors[RegisterFieldEnum.DistrictId] = 'District Code Required';
  }

  if (!values[RegisterFieldEnum.Username]) {
    errors[RegisterFieldEnum.Username] = 'Username Required';
  }

  if (
    values[RegisterFieldEnum.Username] &&
    values[RegisterFieldEnum.Username].length > 10
  ) {
    errors[RegisterFieldEnum.Username] =
      'Username must not exceed 10 characters.';
  }

  if (props.isFirstRegistration) {
    if (!values[RegisterFieldEnum.NewUsername]) {
      errors[RegisterFieldEnum.NewUsername] = 'New Username Required';
    }

    if (
      values[RegisterFieldEnum.NewUsername] &&
      values[RegisterFieldEnum.NewUsername].length > 10
    ) {
      errors[RegisterFieldEnum.NewUsername] =
        'New Username must not exceed 10 characters.';
    }

    if (!values[RegisterFieldEnum.FiscalYear]) {
      errors[RegisterFieldEnum.FiscalYear] = 'Fiscal year is required';
    }

    if (
      !values[RegisterFieldEnum.LicenseFile] ||
      values[RegisterFieldEnum.LicenseFile].length === 0
    ) {
      errors[RegisterFieldEnum.LicenseFile] = 'License is required';
    } else if (values[RegisterFieldEnum.LicenseFile][0].size > 1000000) {
      errors[RegisterFieldEnum.LicenseFile] =
        'File size must be less than 1MB.';
    }
  }

  if (!values[RegisterFieldEnum.OldPassword]) {
    errors[RegisterFieldEnum.OldPassword] = 'Old Password Required';
  }

  if (!values[RegisterFieldEnum.NewPassword]) {
    errors[RegisterFieldEnum.NewPassword] = 'New Password Required';
  }

  if (
    (values[RegisterFieldEnum.NewPassword] &&
      values[RegisterFieldEnum.NewPassword].length < 6) ||
    (values[RegisterFieldEnum.ConfirmPassword] &&
      values[RegisterFieldEnum.ConfirmPassword].length < 6)
  ) {
    errors[RegisterFieldEnum.ConfirmPassword] =
      'The password must be at least 6 characters.';
  }

  if (!values[RegisterFieldEnum.ConfirmPassword]) {
    errors[RegisterFieldEnum.ConfirmPassword] = 'Confirm Password Required';
  }

  if (
    values[RegisterFieldEnum.ConfirmPassword] &&
    values[RegisterFieldEnum.ConfirmPassword].length > 0 &&
    values[RegisterFieldEnum.NewPassword] &&
    values[RegisterFieldEnum.NewPassword].length > 0 &&
    values[RegisterFieldEnum.NewPassword] !==
      values[RegisterFieldEnum.ConfirmPassword]
  ) {
    errors[RegisterFieldEnum.ConfirmPassword] = 'The new passwords must match';
  }

  if (
    values[RegisterFieldEnum.Email] &&
    _.trim(values[RegisterFieldEnum.Email]).length > 0 &&
    !isValidEmail(values[RegisterFieldEnum.Email])
  ) {
    errors[RegisterFieldEnum.Email] = 'Please enter a valid email address.';
  }

  return errors;
};

export default reduxForm({
  validate,
  form: 'RegistrationForm',
})(RegistrationForm);



// WEBPACK FOOTER //
// ./src/pages/login/components/RegistrationForm.js